module.exports = __webpack_public_path__ + "9773c8d1e4cd1fbc9ac5978313ff737a.svg";